export function PdfViewer() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Vaša prava</h1>
          <p className="text-lg text-gray-600">Vodič za prava građana tokom protesta i policijskih akcija</p>
        </div>

        {/* PDF Viewer */}
        <div className="bg-white rounded-2xl shadow-lg p-4 border border-gray-100">
          <div className="w-full h-screen md:h-[800px]">
            <iframe
              src="/vodic-moja-prava_4c23d61e-ff65-48ea-8900-af717ea1fa7a_dcb0b119-4864-4a30-aa32-632a4b786db4.pdf"
              className="w-full h-full border-0 rounded-lg"
              title="Vodič za prava građana"
            />
          </div>
          
          {/* Download Link */}
          <div className="mt-4 text-center">
            <a
              href="/vodic-moja-prava_4c23d61e-ff65-48ea-8900-af717ea1fa7a_dcb0b119-4864-4a30-aa32-632a4b786db4.pdf"
              download
              className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Preuzmi PDF
            </a>
          </div>
        </div>
      </div>
    </div>
  )
} 